import { Text, Timeline } from "@mantine/core";
import {
  IconCameraCheck,
  IconCalendarEvent,
  IconCamera,
  IconHanger,
  IconInbox,
  IconRocket,
} from "@tabler/icons-react";
import { DateDisplay } from "core/components/index";
import { AppConstants } from "utils/constants";
import { getStatusColor } from "utils/helper";
import {
  InventoryStatusTypes,
  getInventoryLifecycle,
} from "modules/Inventory/inventoryStatus";

const STEP_ICONS = {
  [InventoryStatusTypes.NOT_YET_ACTIONED.value]: IconInbox,
  [InventoryStatusTypes.SAMPLE_ACQUIRED.value]: IconHanger,
  [InventoryStatusTypes.SESSION_SCHEDULED.value]: IconCalendarEvent,
  [InventoryStatusTypes.CAPTURED.value]: IconCamera,
  [InventoryStatusTypes.POST_PRODUCTION.value]: IconCameraCheck,
  [InventoryStatusTypes.DISTRIBUTED.value]: IconRocket,
};

// Lifecycle of an inventory record, from received through to distributed.
// Steps up to the record's derivedStatus are filled in; later steps are dimmed.
const StatusTimeline = ({ item }) => {
  if (!item) return null;

  const { steps, activeIndex } = getInventoryLifecycle(item);
  const currentColor = getStatusColor(item.derivedStatus) ?? "gray";

  return (
    <Timeline
      active={activeIndex}
      bulletSize={24}
      lineWidth={2}
      color={currentColor}
    >
      {steps.map((step, idx) => {
        const Icon = STEP_ICONS[step.type.value];
        const reached = idx <= activeIndex;
        const isCurrent = idx === activeIndex;

        return (
          <Timeline.Item
            key={step.type.value}
            bullet={<Icon size={12} stroke={AppConstants.ICON_STROKE_WIDTH} />}
            title={
              <Text size="sm" fw={isCurrent ? 700 : 500} c={reached ? undefined : "dimmed"}>
                {step.title}
              </Text>
            }
          >
            {step.date ? (
              <Text size="xs" c="dimmed">
                <DateDisplay value={step.date} />
              </Text>
            ) : null}
            {step.detail ? (
              <Text size="xs" c="dimmed">
                {step.detail}
              </Text>
            ) : null}
            {reached && !step.date && !step.detail ? (
              <Text size="xs" c="dimmed">
                No date recorded
              </Text>
            ) : null}
          </Timeline.Item>
        );
      })}
    </Timeline>
  );
};

export default StatusTimeline;
